var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$msal.isSignedIn)?_c('LogoutButton'):_c('LoginButton')
}
var staticRenderFns = []

export { render, staticRenderFns }